import { createApp } from 'vue';
import WebpToAvifConverter from '../Components/WebpToAvifConverter.vue';

const root = document.getElementById('webp-to-avif-converter');
if (root) {
  createApp(WebpToAvifConverter).mount('#webp-to-avif-converter');
}
